var map = {
	"./IELTS-min.png": 6502,
	"./TOEFL-min.png": 632,
	"./cambridge-min.png": 3461,
	"./teacher-min.png": 3455,
	"./teacher_mini_1-min.png": 9367,
	"./teacher_mini_2-min.png": 3064,
	"./teacher_mini_3-min.png": 8760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3057;